import React from 'react';
import {Select} from 'antd';

import './index.styl';

class Selectc extends Select{
    render() {
        return (
            <Select {...this.props} />
        )
    }
}

export default Selectc;
